"use strict";

import {findAllIn, on, closest, findIn} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import {updatePristine} from "./form-validation";

export function init() {
    onFind('.js-check-all', function (checkboxAll) {
        let checkboxGroup = closest('.js-check-all-group', checkboxAll),
            checkboxes = findAllIn('input[type="checkbox"]', checkboxGroup);

        on('change', function () {
            checkboxes.map((checkboxItem) => {
               if (checkboxAll.checked) {
                   checkboxItem.checked = true;
                   checkboxItem.required = true;
               } else {
                   checkboxItem.checked = null;
                   checkboxItem.required = false;
               }
            });

            updatePristine(closest('.js-form-validation', checkboxAll));
        }, checkboxAll);
    });
}